module.exports = __webpack_public_path__ + "./docs/img/icon-typedef.e195d50aebf015065f40ccc227d0c662.svg";